/** How long the red "call rejected" bar stays before the call leaves this tab. */
export const CALL_REJECTED_SHOWN_MS = 1500;
